import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/like.svg'


const _withScopeId = n => (_pushScopeId("data-v-92bee3d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col w-full bg-blue-0" }
const _hoisted_2 = { class: "mb-4 font-bold text-lg justify-between md:mt-0 mt-4 bg-red-5" }
const _hoisted_3 = { class: "pl-2" }
const _hoisted_4 = { class: "container sm:w-[768px] w-full sm:px-8 sm:py-8 px-4 py-2 flex flex-col min-h-screen" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "sm:w-9/12 w-8/12 h-full flex flex-col space-y-2 bg-red-0" }
const _hoisted_7 = { class: "text-sub font-medium sm:text-sm text-xs" }
const _hoisted_8 = { class: "sm:ps-4 ps-2" }
const _hoisted_9 = { class: "font-medium text-sm sm:text-base" }
const _hoisted_10 = { class: "sm:text-sm text-xs text-[#838383] h-auto sm:line-clamp-2 line-clamp-1 w-full sm:w-full bg-red-0" }
const _hoisted_11 = { class: "text-xs text-sub flex space-x-2 pt-0" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "mr-1"
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "sm:flex"
}
const _hoisted_14 = { class: "w-24 h-24 sm:w-36 sm:h-36 absolute top-4 sm:top-0 right-0" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full border-solid border-b border-zinc-100 sm:my-4 my-1" }, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "w-full justify-center items-center flex my-10"
}
const _hoisted_18 = {
  key: 1,
  class: "w-full h-32 flex justify-center items-center"
}

import {  ref, watch, onMounted, computed} from 'vue';
import LoadingCircle from '@/components/UI/LoadingCircle.vue'
import { timeForToday } from '@/utils/timeForToday';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import ScrollTopBtn from '@/components/UI/ScrollTop.vue'

interface Item {
    id: number;
    title: string;
    name: string;
    imgURL1: string;
    content: string;
    price: number;
    create_at: string;
    location: string;
    like_cnt: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BoardList',
  setup(__props) {

const clickedItem = ref<Item | null>(null); 
const store = useStore();
const router = useRouter();
const route = useRoute();
const isBoardLoading = ref(false);
const categoryNumber = () => {
    if(route.path.includes('community')) return 1;
    if(route.path.includes('qna')) return 2 ;
    if(route.path.includes('gallery')) return 3;

}



const rst = computed(()=> store.state.currentCommunityList)


const loadMore = async () => {
    isBoardLoading.value = true;
    await new Promise<void>(resolve => {
            setTimeout(() => {
                store.dispatch('fetchCommData', categoryNumber());
                resolve();
            }, 2100);
        });
      isBoardLoading.value =false;

};


onMounted(() => {
    store.dispatch('fetchCommData', categoryNumber());
})

// 상세보기 
const postDetail = (item :Item) => {
    clickedItem.value = item;
    router.push({ path: `community/${item.id}` });
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(categoryNumber() ===1 ? '자유게시판' : '질문&답변'), 1)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rst.value, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          class: "relative"
        }, [
          _createElementVNode("div", {
            class: "w-full sm:h-40 h-auto cursor-pointer bg-red-0 py-4",
            onClick: ($event: any) => (postDetail(item))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, [
                _createTextVNode(_toDisplayString(item.name) + " ", 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(timeForToday)(item.create_at)), 1)
              ]),
              _createElementVNode("p", _hoisted_9, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(item.content), 1),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(item.like_cnt), 1)
              ])
            ]),
            (item.imgURL1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("img", {
                      src: item.imgURL1,
                      alt: "",
                      class: "w-full h-full object-cover rounded-xl bg-zinc-100"
                    }, null, 8, _hoisted_15)
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_5),
          _hoisted_16
        ]))
      }), 128)),
      _createVNode(ScrollTopBtn)
    ]),
    (isBoardLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(LoadingCircle)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("button", {
            onClick: loadMore,
            class: "w-40 h-10 rounded-full border-zinc-500 border border-solid"
          }, "더보기")
        ]))
  ]))
}
}

})